<template>
  <div
    class="bg-grey row justify-center items-center relative-position"
    style="height: 50px; width: 100px; border-radius: 10px"
  >
    <!-- :stripe="stripe" -->
    <q-linear-progress
      class="absolute-full"
      :value="100"
      :color="color"
      style="width: 100%; height: 100%; z-index: 2; border-radius: 10px"
    >
    </q-linear-progress>
    <div
      class="absolute-full flex flex-center text-blod text-white"
      style="z-index: 2; "
    >
      {{ direction === "front" ? `${text}-Fr` : `${text}-Re` }}
    </div>

    <div
      class="absolute fit background"
      v-show="stripe"
      style="
        top: 0;
        left: 0;
        z-index: 1;
        background-color: #fff;
        border-radius: 10px;
      "
      :class="{ animation: stripe }"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { FunctionStatus } from "../../helper/dmc";

interface Props {
  direction: string;
  status: FunctionStatus;
  switching: string;
}
const props = withDefaults(defineProps<Props>(), {
  direction: "front",
  switching: "dTCS",
});

const color = computed(() => {
  return props.status === "disable" ? "grey" : "green";
});
const text = computed(() => {
  return props.switching === "dTCS" ? "DMC" : "MOT";
});
const stripe = computed(() => {
  return props.status === "active" ? true : false;
});
</script>
<style scoped lang="scss">
.animation {
  box-shadow: #fff 0px 0px 80px 50px;
  animation: shadowExpand 1s ease-in-out infinite;
}
@keyframes shadowExpand {
  0% {
    /* border-radius: 50%; */
    transform: translateZ(0);
    transform: scale(0.6);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 0px 0px; */
  }
  50% {
    /* border-radius: 50%; */
    transform: translateZ(0);
    transform: scale(0.9);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 40px 8px; */
  }
  100% {
    /* border-radius: 50%; */
    transform: translateZ(0);
    transform: scale(0.6);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 0px 0px; */
  }
}
</style>
